import HomeOutlineThree from '@assets/icons/home-outline-three.svg'
import { Icon } from './Icon'

export const HomeOutlineThreeIcon = Icon(HomeOutlineThree)
